import { number, shape } from 'prop-types';

export const Point = shape({
  x: number.isRequired,
  y: number.isRequired
});